var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FaqCategory',{attrs:{"faqCategory":_vm.faqCategory,"buttonLoading":_vm.buttonLoading},on:{"saveFaqCategory":_vm.saveFaqCategory}})
}
var staticRenderFns = []

export { render, staticRenderFns }